import { render, staticRenderFns } from "./OrderMailPopup.vue?vue&type=template&id=51a77e16"
import script from "./OrderMailPopup.vue?vue&type=script&lang=ts"
export * from "./OrderMailPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports